import Vue from 'vue'
import Vuex from 'vuex'
import enums from '@/store/enums/enums'
// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import zirehState from './zireh-state/index'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    enums,
    zirehState,
  },
  strict: process.env.DEV,
})
